import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ONE_HOUR_NUMBER, ONE_MINUTE_NUMBER } from '../constant';
import {lastUpdateTimeService} from "../services/lastUpdateTimeService";

const LastUpdateTime = ({ itemSaveService }) => {
    const { i18n } = useTranslation();
    const [currentUpdateTime, setCurrentUpdateTime] = useState({value: 0, format: 'min'});
    const [lastUpdate, setLastUpdate] = useState(null);

    useEffect(() => {
        let interval;
        if(lastUpdate) {
            setCurrentUpdateTime({value: 0, format: 'min'});
            interval = setInterval(() => {
                const value = Math.round((Date.now() - itemSaveService.getDateLastUpdate()) / ONE_MINUTE_NUMBER);
                if(value > ONE_HOUR_NUMBER * 3) {
                    setCurrentUpdateTime({value: null, format: 'min'});
                    clearInterval(interval);
                } else {
                    setCurrentUpdateTime({value: value > ONE_HOUR_NUMBER ? Math.round(value / ONE_HOUR_NUMBER) : value, 
                        format: value > ONE_HOUR_NUMBER ? 'hour' : 'min'});
                }
            }, ONE_MINUTE_NUMBER);
        }
        return () => {
            clearInterval(interval);
        };

    },[lastUpdate]);

    useEffect(() => {
        lastUpdateTimeService.registerUpdateEventObserver(changeLastUpdate);
        return () => lastUpdateTimeService.unRegisterUpdateEventObserver(changeLastUpdate);
    }, [itemSaveService]);

    const changeLastUpdate = () => {
        setLastUpdate(itemSaveService.getDateLastUpdate());
    };

    return (
        itemSaveService.getDateLastUpdate() && currentUpdateTime.value !== null ? 
            <p className="block__text product__timer">
                {i18n.t('app.page.product.updated')} {currentUpdateTime.value + ' '}
                {i18n.t(`app.page.product.${currentUpdateTime.format}`)} {i18n.t('app.page.product.ago')}
            </p>
            :
            null
    );
};

export default LastUpdateTime;
